export function minutesToHours(minutes) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;

    return `${h} соат ${m} дақиқа`;
}